/**
 * 场馆模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取场馆列表
export const deptList = (params) => {
  return req.get('/system/dept/list', params);
}

// 新增场馆
export const deptAdd = (params) => {
  return req.post('/system/dept', params);
}

// 获取场馆详细信息
export const deptInfo = (deptId) => {
  return req.get(`/system/dept/${deptId}`);
}

// 修改场馆信息
export const deptEdit = (params) => {
  return req.put('/system/dept', params);
}

// 删除场馆信息
export const deptDelete = (deptId) => {
  return req.delete(`/system/dept/${deptId}`);
}

// 获取药事中心
export const getDrugCenterList = (params) => {
  return req.get(`/system/dept/drugCenter/list`, params);
}